import Tab from "components/Tab";
import WebPrivacy from "../../../../contents/docs/session-replay/_snippets/web-privacy.mdx";
import AndroidPrivacy from "../../../../contents/docs/session-replay/_snippets/android-privacy.mdx";
import IOSPrivacy from "../../../../contents/docs/session-replay/_snippets/ios-privacy.mdx";
import ReactNativePrivacy from "../../../../contents/docs/session-replay/_snippets/react-native-privacy.mdx";
import FlutterPrivacy from "../../../../contents/docs/session-replay/_snippets/flutter-privacy.mdx";
import * as React from 'react';
export default {
  Tab,
  WebPrivacy,
  AndroidPrivacy,
  IOSPrivacy,
  ReactNativePrivacy,
  FlutterPrivacy,
  React
};